// Dependecies
import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Popup from 'reactjs-popup';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Rate } from 'antd';
import 'antd/dist/antd.css';
import { withTranslation, useTranslation } from 'react-i18next';

// Images
import closeIcon from '../../../sass/images/icons/close.svg';
import alert from '../../../sass/images/alert/alert.svg';
 
import useFormInProcess from '../../hooks/useFormInProcess';


function Modal({
  open,
  close,
  icon,
  title,
  description,
  classNameBtn,
  accept,
  go,
  modalDesign,
  classNameContent,
  showQuestion,
  showQuestionStar,
  showQuestionStarInvert,
  question,
  answers,
  idService,
  back,
  btnClose,
  btnAccept,
  onSubmit,
  onSubmitSatisfactionQuestionnaire,
  star,
  setStar,
  classNameBase,
  alertError,
  children,
}) {

  const { register, handleSubmit, errors, watch, setValue, formState } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUnregister: true,
  });

  const { isSubmitting } = formState;

  const {
    handleImageChange,
    removeImage,
    validateFile,
  } = useFormInProcess(idService, setValue, watch);
  
  const file = watch(`file`) || [];

  const { t } = useTranslation('modal');
  const [isCompleted, setIsCompleted] = useState(false);

  return (
    <>
      <Popup open={open} className={`${classNameBase}`}>
        {modalDesign ? <div className="modal-design" id="modal-design" /> : ''}
        <div className={`popup-base ${classNameContent}`}>
          <button type="button" className="close" onClick={close}>
            <img className="modal-image" src={closeIcon} alt={t('alt:close')} />
          </button>
          <div className="modal-content">
            <div className="modal-heading-box">
              {icon !== '' ? (
                <img className="modal-image" src={icon} alt={t('alt:response')} />
              ) : (
                ''
              )}
            </div>
            <h3 className="title-pop-up" align="center">
              {title}
            </h3>

            <div className="txt-box">
              <p>{description}</p>
            </div>
            {showQuestion ? (
              <div className="question-box">
                <p>{question}</p>
                <form key={1} onSubmit={handleSubmit((data) => onSubmit(data, idService))}>
                  <Col sm={12}>
                  {answers.map((answer, index) => (
                    <Form.Check
                      type="radio"
                      ref={register({
                        required: { value: true, message: t('required') },
                      })}
                      label={answer}
                      value={answer}
                      name="formDeny"
                      id={`formRadios${index}`}
                    />
                  ))}
                     
                    <div className="modal-form">
                      <Button variant="light" className="btn_modal" onClick={close}>
                        {back}
                      </Button>
                      <button id="BtnSubmitDeny" type="submit" className={classNameBtn}>
                        {go}
                      </button>
                    </div>
                  </Col>
                </form>
              </div>
            ) : (
              ''
            )}

            {showQuestionStar ? (
              <div className="question-box-start">
                <p>{question}</p>
                <form
                  onSubmit={handleSubmit((data) =>
                    onSubmitSatisfactionQuestionnaire(data, idService)
                  )}
                >
                  <div className="modal-form form-qualify">
                    <div>
                      <p>{t('description')}</p>
                      <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        placeholder={t('example')}
                        type="text"
                        ref={register({
                          required: {
                            value: true,
                            message: t('required'),
                          },
                          maxLength: {
                            value: 600,
                            message: t('max'),
                          },
                          minLength: {
                            value: 3,
                            message: t('min'),
                          },
                        })}
                        onChange={(e) => {
                          setIsCompleted(e.target.value.length > 0);
                        }}
                      />
                      {errors.description && (
                        <div className="error_input">
                          <p>
                            <img src={alert} alt={t('alt:response')} />
                            {errors.description.message}
                          </p>
                        </div>
                      )}
                    </div>
                    <div>
                      <p className="ant-rate-text">{t('company-attitude')}</p>
                      <Rate
                        name="star"
                        allowClear={false}
                        defaultValue={0}
                        onChange={(res) => setStar(res)}
                      />
                      <input
                        id="stars"
                        name="stars"
                        style={{ display: 'none' }}
                        type="text"
                        value={star}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setIsCompleted(e.target.value.length > 0);
                        }}
                      />
                    </div>
                    <Row className="no-gutters block-items">
                      <Col xs={12} sm={12} md={12} >
                        <p className='ant-rate-text images'>{t('Imágenes del servicio')}*</p>
                        <input
                          className="form-control inputfile inputfile-1"
                          type="file"
                          id={`file`}
                          name={`file`}
                          multiple
                          accept="image/*,.pdf"
                          capture="environment"
                          {...register(`file`, { required: t('required') })}
                          onChange={(e) => handleImageChange(e, `file`)}
                        />
                        <label htmlFor={`file`}>
                          <svg xmlns="http://www.w3.org/2000/svg" className="borrainputfile" width="20" height="17" viewBox="0 0 20 17"><path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"></path></svg>
                          <span className="borrainputfile">{t('formInApproval:select_files')}</span>
                        </label>
                        <div className='list_items_file'>
                          {file.length > 0 && (
                            <ul>
                              {file.map((file, index) => (
                                <li key={index}>
                                  {file.name} <button type="button" onClick={() => removeImage('file', index)}>x</button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        {errors.file && file.length === 0 && (
                          <div className="error_input">
                            <p>
                              <img src={alert} alt={t('alt:response')} />
                              {errors.file.message}
                            </p>
                          </div>
                        )}
                        {validateFile && (
                          <div className="error_input">
                            <p>
                              <img src={alert} alt={t('alt:notification')} />
                              {t('validateFile')}
                            </p>
                          </div>
                        )}
                      </Col>
                    </Row>
                    {alertError && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:response')} />
                          {t('alertError')}
                        </p>
                      </div>
                    )} 
                    <button
                      id="BtnSubmit"
                      type="submit"
                      className={`btn ${isCompleted && file.length > 0 ? 'btn_modal orange' : 'btn_modal gray'}`}
                      disabled={isSubmitting}
                    >
                     {isSubmitting ? t('modal:send') : go}
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              ''
            )}

            {showQuestionStarInvert ? (
              <div className="question-box-start company-modal">
                <form
                  onSubmit={handleSubmit((data) =>
                    onSubmitSatisfactionQuestionnaire(data, idService)
                  )}
                >
                  <div className="modal-form form-qualify qualify-company">
                    <div>
                      <p className="ant-rate-text">{t('workshop-attitude')}</p>
                      <Rate
                        name="star"
                        allowClear={false}
                        defaultValue={0}
                        onChange={(res) => setStar(res)}
                      />
                      <input
                        id="stars"
                        name="stars"
                        style={{ display: 'none' }}
                        type="text"
                        value={star}
                        ref={register({ required: true })}
                        onChange={(e) => {
                          setIsCompleted(e.target.value.length > 0);
                        }}
                      />
                    </div>
                    <div>
                      <p>{t('description-2')}</p>
                      <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        placeholder={t('write')}
                        type="text"
                        ref={register({
                          required: {
                            value: true,
                            message: t('required'),
                          },
                          maxLength: {
                            value: 600,
                            message: t('max'),
                          },
                          minLength: {
                            value: 3,
                            message: t('min'),
                          },
                          pattern: {
                            value: /[a-zA-Z0-9]$/i,
                            message: t('char'),
                          },
                        })}
                        onChange={(e) => {
                          setIsCompleted(e.target.value.length > 0);
                        }}
                      />
                      {errors.description && (
                        <div className="error_input">
                          <p>
                            <img src={alert} alt={t('alt:response')} />
                            {errors.description.message}
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      id="BtnSubmit"
                      type="submit"
                      className={isCompleted ? 'btn_modal orange' : 'btn_modal gray'}
                    >
                      {go}
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              ''
            )}

            {children && <div className="modal-children">{children}</div>}

            <div className="modal-form">
              {btnClose ? (
                <Button variant="light" className="btn_modal" onClick={close}>
                  {back}
                </Button>
              ) : (
                ''
              )}
              {btnAccept ? (
                <button type="button" className={classNameBtn} onClick={accept}>
                  {go}
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  accept: PropTypes.func,
  close: PropTypes.func,
  classNameBtn: PropTypes.string,
  icon: PropTypes.string,
  go: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  modalDesign: PropTypes.bool.isRequired,
  classNameContent: PropTypes.string.isRequired,
  showQuestion: PropTypes.bool,
  showQuestionStar: PropTypes.bool,
  showQuestionStarInvert: PropTypes.bool,
  question: PropTypes.string,
  answers: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  idService: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  back: PropTypes.string,
  btnClose: PropTypes.bool,
  btnAccept: PropTypes.bool,
  inProcess: PropTypes.bool,
  onSubmit: PropTypes.func,
  onSubmitSatisfactionQuestionnaire: PropTypes.func,
  star: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setStar: PropTypes.func,
  classNameBase: PropTypes.string,
  alertError: PropTypes.bool,
  children: PropTypes.node,
};

Modal.defaultProps = {
  icon: '',
  classNameBtn: '',
  go: 'Go',
  title: '',
  description: '',
  showQuestion: false,
  showQuestionStar: false,
  showQuestionStarInvert: false,
  question: '',
  answers: [],
  idService: '',
  back: '',
  btnAccept: false,
  btnClose: false,
  inProcess: false,
  star: '',
  classNameBase: '',
  alertError: false,
};

export default withTranslation(['modal', 'alt', 'jobRequest', 'formInApproval'])(Modal);
